import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  requireNodeFetch19juc7kebtu9r as requireNodeFetch,
  AbortController21osa5gzjz756 as AbortController,
  asByteArray2l3hscb95qi13 as asByteArray,
  readChunk1th39iljl2v8p as readChunk,
} from './Js.mjs';
import { get_isNodeu9kqlebvup92 as get_isNode } from '../../internal/is-node.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { awaitd1m8y0em728c as await_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { Builder1mo34du82b3c6 as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  disposehycj9shx8d5q as dispose,
  HttpEngine345320iy1heif as HttpEngine,
} from './HttpEngine.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DefaultHttpEngine(timeoutMillis) {
  timeoutMillis = timeoutMillis === VOID ? 60000n : timeoutMillis;
  return JsHttpEngine().c6d(timeoutMillis);
}
var JsHttpEngineClass;
function JsHttpEngine() {
  if (JsHttpEngineClass === VOID) {
    class $ {
      static d6d(connectTimeoutMillis, readTimeoutMillis) {
        var $this = createThis(this);
        $this.z6c_1 = connectTimeoutMillis;
        $this.a6d_1 = readTimeoutMillis;
        $this.b6d_1 = get_isNode() ? requireNodeFetch() : null;
        return $this;
      }
      static c6d(timeoutMillis) {
        return this.d6d(timeoutMillis, timeoutMillis);
      }
      *r67(request, $completion) {
        var abortController = AbortController();
        var connectTimeoutId = setTimeout(() => {
          abortController.abort();
          return Unit_instance;
        }, this.z6c_1);
        var fetchOptions = toFetchOptions(request, abortController.signal);
        var tmp;
        if (get_isNode()) {
          tmp = this.b6d_1(request.j49_1, fetchOptions);
        } else {
          tmp = fetch(request.j49_1, fetchOptions);
        }
        var responsePromise = tmp;
        var tmp_0;
        try {
          var response = yield* await_0(responsePromise, $completion);
          clearTimeout(connectTimeoutId);
          var tmp_1;
          if (get_isNode()) {
            tmp_1 = yield* readBodyNode(response.body, this.a6d_1, abortController, $completion);
          } else {
            tmp_1 = yield* readBodyBrowser(response.body, this.a6d_1, abortController, $completion);
          }
          var responseBodySource = tmp_1;
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder())(response.status)).c49(responseBodySource);
          var $this$apply = this_0;
          // Inline function 'kotlin.js.asDynamic' call
          response.headers.forEach((value, key) => $this$apply.m48(key, value));
          tmp_0 = this_0.d37();
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var t = $p;
            var tmp_3;
            if (t instanceof CancellationException()) {
              abortController.abort();
              throw t;
            } else {
              throw ApolloNetworkException().h47('Failed to execute GraphQL http network request', t);
            }
          } else {
            throw $p;
          }
        }
        return tmp_0;
      }
      l6() {
      }
    }
    protoOf($).oz = dispose;
    initMetadataForClass($, 'JsHttpEngine', VOID, VOID, [HttpEngine()], [1]);
    JsHttpEngineClass = $;
  }
  return JsHttpEngineClass;
}
function toFetchOptions(_this__u8e3s4, abortSignal) {
  var tmp;
  switch (_this__u8e3s4.i49_1.w1_1) {
    case 0:
      tmp = 'GET';
      break;
    case 1:
      tmp = 'POST';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var method = tmp;
  var headers = {};
  var _iterator__ex2g4s = _this__u8e3s4.k49_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var header = _iterator__ex2g4s.r1();
    headers[header.w48_1] = header.x48_1;
  }
  var tmp1_safe_receiver = _this__u8e3s4.l49_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    headers['Content-Type'] = tmp1_safe_receiver.k47();
    // Inline function 'kotlin.takeIf' call
    var this_0 = tmp1_safe_receiver.l47();
    var tmp_1;
    if (this_0 >= 0n) {
      tmp_1 = this_0;
    } else {
      tmp_1 = null;
    }
    var tmp0_safe_receiver = tmp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      headers['Content-Length'] = tmp0_safe_receiver.toString();
    }
    var bodyBuffer = new (Buffer())();
    tmp1_safe_receiver.n47(bodyBuffer);
    tmp_0 = bodyBuffer.m3y();
  }
  var bodyBytes = tmp_0;
  // Inline function 'com.apollographql.apollo.network.http.dynamicObject' call
  var init = ($this$dynamicObject) => {
    $this$dynamicObject.signal = abortSignal;
    $this$dynamicObject.method = method;
    $this$dynamicObject.headers = headers;
    var tmp;
    if (!(bodyBytes == null)) {
      tmp = $this$dynamicObject.body = bodyBytes;
    }
    return Unit_instance;
  };
  var js = {};
  init(js);
  return js;
}
function *readBodyNode(body, readTimeoutMillis, abortController, $completion) {
  var readTimeoutId = {_v: setTimeout(() => {
    abortController.abort();
    return Unit_instance;
  }, readTimeoutMillis)};
  var bufferedSource = new (Buffer())();
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.v10();
    var continuation = cancellable;
    body.on('data', (chunk) => {
      clearTimeout(readTimeoutId._v);
      readTimeoutId._v = setTimeout(() => {
        abortController.abort();
        return Unit_instance;
      }, readTimeoutMillis);
      var chunkBytes = asByteArray(new Uint8Array(chunk));
      return bufferedSource.u3y(chunkBytes);
    });
    body.on('end', () => {
      var tmp0 = continuation;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = bufferedSource;
      var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
      tmp0.oc(tmp$ret$5);
      return Unit_instance;
    });
    body.on('error', (error) => {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(error));
      this_0.oc(tmp$ret$7);
      return Unit_instance;
    });
    return cancellable.fy();
  };
}
function *readBodyBrowser(body, readTimeoutMillis, abortController, $completion) {
  var readTimeoutId = setTimeout(() => {
    abortController.abort();
    return Unit_instance;
  }, readTimeoutMillis);
  var bufferedSource = new (Buffer())();
  var tmp;
  if (body == null) {
    return new (Buffer())();
  } else {
    tmp = body;
  }
  var stream = tmp;
  var reader = stream.getReader();
  $l$loop: while (true) {
    try {
      var chunk = yield* readChunk(reader, $completion);
      clearTimeout(readTimeoutId);
      readTimeoutId = setTimeout(() => {
        abortController.abort();
        return Unit_instance;
      }, readTimeoutMillis);
      if (chunk == null) {
        break $l$loop;
      }
      bufferedSource.u3y(asByteArray(chunk));
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        reader.cancel(cause);
        throw cause;
      } else {
        throw $p;
      }
    }
  }
  return bufferedSource;
}
//region block: exports
export {
  DefaultHttpEngine as DefaultHttpEngine26xguluicr03l,
};
//endregion

//# sourceMappingURL=DefaultHttpEngine.js.mjs.map
